import { OmitDistributive } from '@core/common-legacy';
import type {
  OptionalId,
  ReportDashboardComponent,
  ReportDashboardComponentViewData,
  ReportDashboardGridComponent,
} from '@core/reports-types';
import { getNextGridPosition } from '@core/reports-util';
import { generateUuid } from '@core/utils-legacy';

export const beforeComponentCreate = (
  component: ReportDashboardComponentViewData | OptionalId<ReportDashboardComponent>,
  correlationId: string = generateUuid(),
  gridPositionOptions:
    | {
        resolveGridPosition: true;
        dashboardGrid: ReportDashboardGridComponent[];
      }
    | {
        resolveGridPosition: false;
      },
): OmitDistributive<ReportDashboardComponent, 'id'> => {
  let result: ReportDashboardComponentViewData;
  if ('id' in component) {
    const { id, ...rest } = component;
    result = <ReportDashboardComponentViewData>rest;
  } else {
    result = <ReportDashboardComponentViewData>component;
  }

  return {
    ...result,
    localId: correlationId,
    grid: gridPositionOptions.resolveGridPosition
      ? getNextGridPosition(gridPositionOptions.dashboardGrid, component.grid)
      : result.grid,
  };
};
